import { render } from "./PageNotFound.vue?vue&type=template&id=46073e26&scoped=true&bindings={}"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=46073e26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46073e26"

export default script